import React from 'react';

import LandingPage from 'components/shared/LandingPage';
import PageHeader from 'components/shared/LandingPage/blocks/PageHeader';
import LandingPageContext from 'components/shared/LandingPage/contexts/LandingPageContext';
import { getLangingPageType } from 'utils/itineraries/functions';

import { IRenderBuilderPageHeaderProps } from '../types';
import { useLandingContext } from './functions';
import s from './index.module.css';
import { IBuilderProps } from './types';

const defaultRenderPageHeader = ({ links, pageIndex }: IRenderBuilderPageHeaderProps) => {
  if (pageIndex !== 0) return null;

  return <PageHeader links={links} disabled />;
};

function Builder({ renderStartArrow, ...props }: IBuilderProps) {
  const { screens, pageIndex, isSamplePreview, landingTheme, renderPageHeader = defaultRenderPageHeader } = props;
  const landingPageType = getLangingPageType(props.landingData);
  const contextValue = useLandingContext({
    ...props,
    landingPageType,
    isSamplePreview,
    isInsideBuilder: true,
    landingTheme,
  });

  return (
    // @ts-ignore
    <LandingPageContext.Provider value={contextValue}>
      {renderPageHeader({ pageIndex, links: screens })}

      <LandingPage
        index={pageIndex}
        // @ts-ignore
        links={screens}
        renderStartArrow={renderStartArrow}
        className={s.builder}
        landingPageType={landingPageType}
        anchor={props?.anchor}
        landingTheme={landingTheme}
      />
    </LandingPageContext.Provider>
  );
}

export default Builder;
